export const NAME = 'dashboard';
